import React from 'react';
import { ToggleButtonGroup as BootstrapToggleButtonGroup } from 'react-bootstrap';
import './index.css';

export function ToggleButtonGroup({ type = 'radio', role = 'group', children, ...props }) {
  return (
    <BootstrapToggleButtonGroup type={type} role={role} {...props}>
      {children}
    </BootstrapToggleButtonGroup>
  );
}
